<template>
  <button
    class="button"
    :class="btnClasses[color]"
    :type="type"
    :disabled="invalid"
  >
    <slot />
  </button>
</template>

<script>
export default {

  name: 'DSButton',

  props: {
    color: {
      type: String,
      default: 'secondary',
    },
    type: {
      type: String,
      default: 'button',
    },
    invalid: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      btnClasses: {
        secondary: 'button--standard',
        primary: 'button--standard',
        warning: 'button--warning',
      },
    }
  },
}
</script>

<style lang="css" scoped>
.button {
  margin-bottom: 0;
}
</style>
